import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService, ToastType } from '@core/services/toast.service';

const TOAST_TYPE_CLASSES: Record<ToastType, string> = {
  success: 'bg-(--status-success-bg) text-(--status-success-fg)',
  info: 'bg-(--status-info-bg) text-(--status-info-fg)',
  warning: 'bg-(--status-warning-bg) text-(--status-warning-fg)',
  error: 'bg-(--status-error-bg) text-(--status-error-fg)',
};

const TOAST_DISMISS_CLASSES: Record<ToastType, string> = {
  success: 'text-(--status-success-accent)',
  info: 'text-(--status-info-accent)',
  warning: 'text-(--status-warning-accent)',
  error: 'text-(--status-error-accent)',
};

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainer {
  protected readonly toastService = inject(ToastService);

  protected toastClasses(type: ToastType): string {
    return TOAST_TYPE_CLASSES[type];
  }

  protected dismissClasses(type: ToastType): string {
    return TOAST_DISMISS_CLASSES[type];
  }
}
